<div class="modal-content custom-dialog">
    <div class="modal-header border-0">
        <div>
            <h5 class="modal-title fs-6 fw-bold m-0">{{ mode === 'edit' ? 'Edit Project' : 'Add New Project' }}</h5>
            <p class="text-muted small mb-0 mt-1">
                {{ mode === 'edit' ? 'Update project details, naming convention, or color code.' : 'Create a new project
                with naming convention and color code.' }}
            </p>
        </div>
        <button type="button" class="close-btn" mat-dialog-close title="Cancel">✕</button>
    </div>

    <hr class="divider" />

    <mat-dialog-content class="modal-body">
        <!-- Naming Mode Tabs -->
        <div class="tab-header mb-3">
            <button type="button" [class.active]="namingMode === 'standard'"
                (click)="onTabChange('standard')">
                Standard Naming
            </button>
            <button type="button" [class.active]="namingMode === 'custom'"
                (click)="onTabChange('custom')">
                Custom Naming
            </button>
        </div>

        <form [formGroup]="projectForm">
            <!-- Standard Naming Section -->
            <div *ngIf="namingMode === 'standard'">
                <div class="form-group">
                    <label>Model Year <span class="required">*</span></label>
                    <input type="text" class="expand-input" placeholder="e.g., 2025" formControlName="modelYear"
                        (input)="onFieldChange()">
                    <span *ngIf="projectForm.get('modelYear')?.invalid && projectForm.get('modelYear')?.touched"
                        class="error-text">
                        Enter a valid year (YYYY)
                    </span>
                </div>

                <div class="form-group">
                    <label>Model Code <span class="required">*</span></label>
                    <input type="text" class="expand-input" placeholder="e.g., 123A" formControlName="modelCode"
                        (input)="onFieldChange()">
                </div>

                <div class="form-group">
                    <label>Project Code <span class="required">*</span></label>
                    <input type="text" class="expand-input" placeholder="e.g., XV70" formControlName="projectCode"
                        (input)="onFieldChange()">
                </div>

                <div class="form-group generated-name-group">
                    <label class="generated-label">
                        <mat-icon class="auto-icon">auto_awesome</mat-icon>
                        Project Name
                    </label>
                    <div class="generated-name-display">
                        <span class="generated-name-value">{{ generatedProjectName }}</span>
                    </div>
                    <span *ngIf="duplicateNameError" class="error-text">{{ duplicateNameError }}</span>
                </div>
            </div>

            <!-- Custom Naming Section -->
            <div *ngIf="namingMode === 'custom'">
                <div class="form-group">
                    <label>Project Name <span class="required">*</span></label>
                    <input type="text" class="expand-input" placeholder="Enter custom project name"
                        formControlName="projectName">
                    <small class="helper-text">Enter your custom project name</small>
                    <span *ngIf="duplicateNameError" class="error-text">{{ duplicateNameError }}</span>
                </div>
            </div>

            <!-- Color Selection Section -->
            <label class="sub-title">Select Project Color Code <span class="required">*</span></label>
            <p class="small text-muted mb-2">Each project gets a unique color identifier.</p>

            <!-- Color mapping warning -->
            <div *ngIf="selectedColorProject" class="color-warning-box">
                <mat-icon>info</mat-icon>
                <span>This color is currently mapped to: <strong>{{ selectedColorProject }}</strong></span>
            </div>

            <div class="color-options-wrapper">
                <div class="color-options">
                    <button type="button" *ngFor="let color of colorOptions" class="color-option"
                        [class.selected]="selectedColor?.code === color.code" (click)="selectColor(color)"
                        [style.border-color]="selectedColor?.code === color.code ? '#cc0000' : '#e5e7eb'">
                        <div class="color-circle" [style.background-color]="color.code"></div>
                        <span class="color-name">{{ color.name }}</span>
                        <!-- <span *ngIf="color.isUnique" class="unique-badge">Unique</span> -->
                    </button>
                </div>
            </div>
            <span *ngIf="colorError" class="error-text">Please select the project color.</span>
        </form>
    </mat-dialog-content>

    <hr class="divider" />

    <div class="modal-footer border-0">
        <button type="button" class="btn btn-outline-secondary btn-cancel" mat-dialog-close>Cancel</button>
        <button type="button" class="btn btn-danger" (click)="submitProject()"
        [disabled]="!selectedColor || duplicateNameError || projectForm.invalid">
		<span>{{ mode === 'edit' ? 'Update Project' : 'Create Project' }}</span>
        </button>
    </div>
</div>